import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { TranslateModule } from '@ngx-translate/core';
import {
  AccountNameGetterModule,
  DaysAgoPipeModule,
  DaysAwayModule,
  PreferredCurrencyModule,
  PipelineSelectorPipeModule,
  SalesOpportunitiesPipesModule,
} from '@vendasta/sales-common';
import { AsyncUiModule, EmptyStateModule, VaStencilsModule, VImgModule } from '@vendasta/uikit';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatCardModule } from '@angular/material/card';
import { PipelineTableComponent } from './pipeline-table.component';
import { PipelineTableServiceModule } from '../pipeline-table-service/pipeline-table-service.module';
import { GetTypeNameFromIdPipe } from './type-name.pipe';

@NgModule({
  declarations: [PipelineTableComponent, GetTypeNameFromIdPipe],
  exports: [PipelineTableComponent, GetTypeNameFromIdPipe],
  providers: [DatePipe, CurrencyPipe],
  imports: [
    CommonModule,
    AsyncUiModule,
    VaStencilsModule,
    TranslateModule,
    GalaxyEmptyStateModule,
    EmptyStateModule,
    VImgModule,
    MatMenuModule,
    RouterModule,
    MatTableModule,
    MatSortModule,
    DaysAwayModule,
    MatCardModule,
    PreferredCurrencyModule,
    DaysAgoPipeModule,
    AccountNameGetterModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    PipelineSelectorPipeModule,
    SalesOpportunitiesPipesModule,
    PipelineTableServiceModule,
  ],
})
export class PipelineTableModule {}
